import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaBackward, FaThumbsUp, FaThumbsDown, FaTrash, FaCalendarAlt, FaTimes } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { dataMysql, bin2hex, buscarCep, extract, bin2base64, data } from '../../../util/util';
import SignatureCanvas from 'react-signature-canvas'
import NavItem from '../../../components/NavItem';
import { toast } from 'react-toastify';
import { getText } from '../../../util/translations';
import ReactSelect from '../../../components/ReactSelect';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import '../../../css/financeiro-parcela-pagar.css';


const normalizarDataLista = (valor) => {
    if (!valor || (typeof valor === 'string' && valor.trim() === '')) {
        return null;
    }

    if (typeof valor === 'string' && valor.startsWith('0000-00-00')) {
        return null;
    }

    let dataMoment = valor;
    if (typeof valor === 'string' && valor.includes('/')) {
        const partes = valor.split('/');
        if (partes.length === 3) {
            const [dia, mes, ano] = partes;
            if (dia && mes && ano && ano.length === 4) {
                const diaNum = parseInt(dia, 10);
                const mesNum = parseInt(mes, 10);
                const anoNum = parseInt(ano, 10);
                if (!Number.isNaN(diaNum) && !Number.isNaN(mesNum) && !Number.isNaN(anoNum) && anoNum >= 1900) {
                    return `${String(diaNum).padStart(2, '0')}/${String(mesNum).padStart(2, '0')}/${anoNum}`;
                }
            }
        }
    }

    try {
        const data = new Date(dataMoment);
        if (Number.isNaN(data.getTime()) || data.getUTCFullYear() < 1900) {
            return null;
        }

        const dia = String(data.getUTCDate()).padStart(2, '0');
        const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
        const ano = data.getUTCFullYear();
        return `${dia}/${mes}/${ano}`;
    } catch (error) {
        return null;
    }
};

const ALTURA_ASSINATURA = 300;

export default function CadastroEventoParticipanteAssinatura({ match }) {
    const idParticipante = match.params.id; // ID do participante
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const history = useHistory();
    let { state } = useLocation();
    const elementoAssinatura = useRef(null);
    const caixaAssinatura = useRef(null);
    const larguraAplicada = useRef(0);
    const assinaturaPendente = useRef(null); // traço guardado enquanto o canvas é redimensionado
    const params = new URLSearchParams(window.location.search);
    const [idEvento, setIdEvento] = useState(null); // Armazenar o ID do evento quando for carregado
    const [isSubmitting, setIsSubmitting] = useState(false);
    // carregamento NÃO bloqueia a tela: o canvas fica utilizável e só o Salvar espera os dados
    const [isLoading, setIsLoading] = useState(!!match.params.id);
    const [larguraAssinatura, setLarguraAssinatura] = useState(0);
    const [showConfirmarDiaModal, setShowConfirmarDiaModal] = useState(false);
    const eventoDaUrl = params.get('evento');

    // Recupera valores da URL
    const datalista = normalizarDataLista(params.get('datalista'));
    const tipoListaPresenca = params.get('tipoListaPresenca');

    // Estado inicial sem valores do localStorage (serão carregados após obter o ID do evento)
    const [dados, setDados] = useState({
        tipoListaPresenca: tipoListaPresenca ? parseInt(tipoListaPresenca) : 1,
        nomeTipoListaPresenca: "Evento",
        data: datalista || null,
        nomeData: datalista || null
    });

    // Efeito para aplicar valores do localStorage após o idEvento ser atualizado
    useEffect(() => {
        if (idEvento) {
            // Agora que temos o ID do evento, recuperamos os valores do localStorage
            const savedTipoListaPresenca = localStorage.getItem(`tipoListaPresenca_${idEvento}`);
            const savedNomeTipoListaPresenca = localStorage.getItem(`nomeTipoListaPresenca_${idEvento}`);
            const savedDataLista = normalizarDataLista(localStorage.getItem(`datalista_${idEvento}`));
            const savedNomeDataLista = normalizarDataLista(localStorage.getItem(`nomeDatalista_${idEvento}`));

            // Só atualizamos se não tiver valores da URL
            if (!tipoListaPresenca && savedTipoListaPresenca) {
                setDados(dadosAtuais => ({
                    ...dadosAtuais,
                    tipoListaPresenca: parseInt(savedTipoListaPresenca),
                    nomeTipoListaPresenca: savedNomeTipoListaPresenca || "Evento"
                }));
            }

            if (!datalista && savedDataLista) {
                setDados(dadosAtuais => ({
                    ...dadosAtuais,
                    data: savedDataLista,
                    nomeData: savedNomeDataLista || savedDataLista
                }));
            }

            // Se temos o tipo de lista no localStorage mas não temos o nome, buscamos o nome
            if (savedTipoListaPresenca && !savedNomeTipoListaPresenca) {
                api({
                    method: 'get',
                    action: '/participanteListaPresencaTipo',
                    token: token,
                    params: { id: savedTipoListaPresenca }
                }).then(response => {
                    const tipoLista = response.data.data.find(item => item.id === parseInt(savedTipoListaPresenca));
                    if (tipoLista) {
                        setDados(dadosAtuais => ({
                            ...dadosAtuais,
                            nomeTipoListaPresenca: tipoLista.nome
                        }));

                        // Salva no localStorage com ID do evento
                        localStorage.setItem(`nomeTipoListaPresenca_${idEvento}`, tipoLista.nome);
                    }
                }).catch(err => {
                    //console.log(err)
                });
            }
        }
    }, [idEvento, tipoListaPresenca, datalista, token]);

    // Efeito para tipo lista da URL
    useEffect(() => {
        if (tipoListaPresenca && idEvento) {
            api({
                method: 'get',
                action: '/participanteListaPresencaTipo',
                token: token,
                params: { id: tipoListaPresenca }
            }).then(response => {
                const tipoLista = response.data.data.find(item => item.id === parseInt(tipoListaPresenca));
                if (tipoLista) {
                    setDados(dadosAtuais => ({
                        ...dadosAtuais,
                        nomeTipoListaPresenca: tipoLista.nome
                    }));

                    // Salva no localStorage com ID do evento
                    localStorage.setItem(`tipoListaPresenca_${idEvento}`, tipoListaPresenca);
                    localStorage.setItem(`nomeTipoListaPresenca_${idEvento}`, tipoLista.nome);
                }
            }).catch(err => {
                //console.log(err)
            });
        }
    }, [tipoListaPresenca, idEvento, token]);

    // A caixa de assinatura acompanha a largura do container (o canvas precisa de width/height em px:
    // esticar por CSS desalinharia o traço do dedo/caneta). Trocar a largura zera o canvas, então o
    // traço em andamento é guardado antes e redesenhado depois, no tamanho em que foi feito.
    useLayoutEffect(() => {
        const caixa = caixaAssinatura.current;

        if (!caixa) {
            return;
        }

        const aplicarLargura = () => {
            const largura = Math.floor(caixa.clientWidth);

            if (largura <= 0 || largura === larguraAplicada.current) {
                return;
            }

            if (larguraAplicada.current > 0 && elementoAssinatura.current && !elementoAssinatura.current.isEmpty()) {
                assinaturaPendente.current = {
                    imagem: elementoAssinatura.current.getCanvas().toDataURL('image/png'),
                    largura: larguraAplicada.current,
                };
            }

            larguraAplicada.current = largura;
            setLarguraAssinatura(largura);
        };

        aplicarLargura();

        if (typeof ResizeObserver === 'undefined') {
            return;
        }

        const observador = new ResizeObserver(aplicarLargura);
        observador.observe(caixa);
        return () => observador.disconnect();
    }, [dados.mostrarTermo]);

    useLayoutEffect(() => {
        const pendente = assinaturaPendente.current;

        if (!pendente || !elementoAssinatura.current) {
            return;
        }

        assinaturaPendente.current = null;
        elementoAssinatura.current.fromDataURL(pendente.imagem, {
            ratio: 1,
            width: pendente.largura,
            height: ALTURA_ASSINATURA,
        });
    }, [larguraAssinatura]);

    // Desenha a assinatura já salva no tamanho original — o canvas agora é mais largo que ela
    const desenharAssinaturaSalva = (base64) => {
        const imagem = new Image();
        imagem.onload = () => {
            const canvas = elementoAssinatura.current?.getCanvas();

            if (!canvas) {
                return;
            }

            const escala = Math.min(1, canvas.width / imagem.width, canvas.height / imagem.height);
            elementoAssinatura.current.fromDataURL(imagem.src, {
                ratio: 1,
                width: imagem.width * escala,
                height: imagem.height * escala,
            });
        };
        imagem.src = "data:image/png;base64," + base64;
    };

    const buscar = () => {
        if (idParticipante) {
            api({
                method: "get",
                action: '/participante/' + idParticipante,
                token: token,
                params: {
                    datalista: datalista,
                    tipoListaPresenca: tipoListaPresenca
                }
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'enderecopais',
                        'aereomunicipioembarque',
                        'enderecomunicipio',
                        'hotelmunicipio',
                        'banco',
                    ]
                });

                if (dadosRecebidos.base64assinatura) {
                    desenharAssinaturaSalva(dadosRecebidos.base64assinatura);
                }

                // Extrair e armazenar o ID do evento
                if (dadosRecebidos.evento && dadosRecebidos.evento.id) {
                    const eventoId = dadosRecebidos.evento.id;
                    setIdEvento(eventoId);

                    // Recuperar valores do localStorage com o ID do evento
                    const savedTipoListaPresenca = localStorage.getItem(`tipoListaPresenca_${eventoId}`);
                    const savedNomeTipoListaPresenca = localStorage.getItem(`nomeTipoListaPresenca_${eventoId}`);
                    const savedDataLista = normalizarDataLista(localStorage.getItem(`datalista_${eventoId}`));
                    const savedNomeDataLista = normalizarDataLista(localStorage.getItem(`nomeDatalista_${eventoId}`));

                    dadosRecebidos.mostrarTermo = false; //nunca mostrar termo
                    if (dadosRecebidos.evento.termoaceiteassinatura && dadosRecebidos.evento.termoaceiteassinatura !== '') { //se evento tiver termo, mostrar
                        dadosRecebidos.mostrarTermo = true;
                        if (dadosRecebidos.aceitetermoassinatura) { //se participante ja estiver respondido, não mostrar mais
                            dadosRecebidos.mostrarTermo = false;
                        }
                    }

                    // Tratamento de datas seguindo ordem de prioridade
                    if (datalista) {
                        // Se veio da URL
                        dadosRecebidos.data = datalista;
                        dadosRecebidos.nomeData = datalista;
                        localStorage.setItem(`datalista_${eventoId}`, datalista);
                        localStorage.setItem(`nomeDatalista_${eventoId}`, datalista);
                    } else if (savedDataLista) {
                        // Se não veio da URL mas tem no localStorage
                        dadosRecebidos.data = savedDataLista;
                        dadosRecebidos.nomeData = savedNomeDataLista || savedDataLista;
                    } else {
                        // Se não tem nem URL nem localStorage
                        const dataEvento = normalizarDataLista(dadosRecebidos.evento.data);
                        dadosRecebidos.data = dataEvento;
                        dadosRecebidos.nomeData = dataEvento;
                        if (dataEvento) {
                            localStorage.setItem(`datalista_${eventoId}`, dataEvento);
                            localStorage.setItem(`nomeDatalista_${eventoId}`, dataEvento);
                        }
                    }

                    // Tratamento do tipo de lista seguindo ordem de prioridade
                    if (tipoListaPresenca) {
                        // Se veio da URL
                        dadosRecebidos.tipoListaPresenca = parseInt(tipoListaPresenca);

                        api({
                            method: 'get',
                            action: '/participanteListaPresencaTipo',
                            token: token,
                            params: { id: tipoListaPresenca }
                        }).then(response => {
                            const tipoLista = response.data.data.find(item => item.id === parseInt(tipoListaPresenca));
                            if (tipoLista) {
                                dadosRecebidos.nomeTipoListaPresenca = tipoLista.nome;
                                // Salva no localStorage com ID do evento
                                localStorage.setItem(`tipoListaPresenca_${eventoId}`, tipoListaPresenca);
                                localStorage.setItem(`nomeTipoListaPresenca_${eventoId}`, tipoLista.nome);
                            }
                            setDados(dadosRecebidos);
                        }).catch(err => {
                            setDados(dadosRecebidos);
                        });
                    } else if (savedTipoListaPresenca) {
                        // Se não veio da URL, mas tem no localStorage
                        dadosRecebidos.tipoListaPresenca = parseInt(savedTipoListaPresenca);
                        dadosRecebidos.nomeTipoListaPresenca = savedNomeTipoListaPresenca || "Evento";
                        setDados(dadosRecebidos);
                    } else {
                        // Se não tem nem na URL nem no localStorage
                        dadosRecebidos.tipoListaPresenca = 1;
                        dadosRecebidos.nomeTipoListaPresenca = "Evento";
                        // Salva no localStorage o valor padrão com ID do evento
                        localStorage.setItem(`tipoListaPresenca_${eventoId}`, "1");
                        localStorage.setItem(`nomeTipoListaPresenca_${eventoId}`, "Evento");
                        setDados(dadosRecebidos);
                    }
                } else {
                    // Se não conseguiu determinar o ID do evento, use os valores padrão
                    setDados(dadosRecebidos);
                }
            }).catch(err => {
                //console.log(err)
            }).finally(() => {
                // libera o Salvar em qualquer desfecho — erro na busca não pode prender a assinatura
                setIsLoading(false);
            });
        }
    };

    // Assinar em dia diferente do de hoje é o erro caro da lista digital: confirma antes de gravar
    const salvar = () => {
        if (isSubmitting) {
            return;
        }

        const diaSelecionado = normalizarDataLista(dados.data);

        if (diaSelecionado && diaSelecionado !== data(new Date())) {
            setShowConfirmarDiaModal(true);
            return;
        }

        enviarAssinatura();
    };

    const enviarAssinatura = () => {
        if (isSubmitting) {
            return;
        }

        const eventoSalvar = idEvento || dados.evento?.id || eventoDaUrl || state?.evento;
        const participanteSalvar = dados.id || idParticipante;
        const dataListaAtual = normalizarDataLista(dados.data);

        if (!eventoSalvar) {
            toast.error(getText('idEventoNaoEncontrado') ?? 'ID do evento não encontrado!');
            return;
        }

        if (!participanteSalvar) {
            toast.error(getText('idParticipanteNaoEncontrado') ?? 'ID do participante não encontrado!');
            return;
        }

        if (!dataListaAtual || !dados.tipoListaPresenca) {
            toast.error(getText('dataTipoListaNaoInformado') ?? 'Informe a data e o tipo da lista!');
            return;
        }

        if (!elementoAssinatura.current) {
            toast.error(getText('error') + (getText('errorRefreshPage') ?? ''));
            return;
        }

        let dadosSalvar = {
            participante: participanteSalvar,
            data: dataListaAtual,
            tipo: dados.tipoListaPresenca,
            imagemassinatura: dados.imagemassinatura,
            binarioImagemAssinatura: bin2hex(elementoAssinatura.current.getCanvas().toDataURL('image/png'))
        };

        localStorage.setItem(`tipoListaPresenca_${eventoSalvar}`, dados.tipoListaPresenca);
        localStorage.setItem(`nomeTipoListaPresenca_${eventoSalvar}`, dados.nomeTipoListaPresenca);
        localStorage.setItem(`datalista_${eventoSalvar}`, dataListaAtual);
        localStorage.setItem(`nomeDatalista_${eventoSalvar}`, normalizarDataLista(dados.nomeData) || dataListaAtual);

        setIsSubmitting(true);
        api({
            method: 'post',
            action: '/participanteListaPresenca',
            token: token,
            data: dadosSalvar,
        })
            .then(function (response) {
                toast.success(getText('assinaturaSalvaSucesso') ?? 'Assinatura salva com sucesso!');
                // volta para a lista sem filtro de nome (campo limpo) e mantendo o dia da lista
                history.push("/eventoParticipante/" + eventoSalvar + "?datalista=" + encodeURIComponent(dataListaAtual));
            })
            .catch(function (error) {
                toast.error((getText('erroAoSalvar') ?? 'Erro ao salvar: ') + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                {['listarsvp'].includes(perfil) ? (
                    <div style={{ marginBottom: 12 }}>
                        <NavItem to={"/eventoParticipante/" + (idEvento || eventoDaUrl || state?.evento || "") + (dados.data ? "?datalista=" + encodeURIComponent(dados.data) : "")} icon={<FaBackward size={20} />} color="outline-dark">Participantes</NavItem>
                    </div>
                ) : null}

                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">{getText('assinatura') ?? 'Assinatura'}</h2>
                        {dados.nome ? <p className="fin-pp__subtitle">{dados.nome}</p> : null}
                    </div>
                </div>

                <div className="fin-pp__card" style={{ padding: '16px 20px' }}>
                    {dados.mostrarTermo ? (
                        <>
                            <div className="fin-pp__filters" style={{ marginBottom: 16 }}>
                                <div className="fin-pp__field fin-pp__field--full">
                                    <label className="fin-pp__label">{getText('termoAceite') ?? 'Termo de Aceite'}</label>
                                    <textarea
                                        className="fin-pp__input"
                                        id="termoaceiteassinatura"
                                        style={{ height: 'auto', minHeight: 400, padding: '10px 14px' }}
                                        value={dados.evento.termoaceiteassinatura}
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--pill"
                                    onClick={() => {
                                        api({
                                            method: 'put',
                                            action: '/participante/' + idParticipante,
                                            token: token,
                                            data: {
                                                ...{ aceitetermoassinatura: "nao" }
                                            }
                                        })
                                            .then(function (response) {
                                                toast.success(getText('aceiteRegistradoSucesso'));
                                                dados.aceitetermoassinatura = 'nao';
                                                dados.mostrarTermo = false;
                                                //setDados(dados); //atualizar state
                                                window.location.reload(false);
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }}>
                                    <FaThumbsDown size={16} style={{ marginRight: 6 }} /> {getText('recusar') ?? 'Recusar'}
                                </button>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                                    onClick={() => {
                                        api({
                                            method: 'put',
                                            action: '/participante/' + idParticipante,
                                            token: token,
                                            data: {
                                                ...{ aceitetermoassinatura: "sim" }
                                            }
                                        })
                                            .then(function (response) {
                                                toast.success(getText('aceiteRegistradoSucesso'));
                                                dados.aceitetermoassinatura = 'sim';
                                                dados.mostrarTermo = false;
                                                //setDados(dados); //atualizar state
                                                window.location.reload(false);
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }}>
                                    <FaThumbsUp size={16} style={{ marginRight: 6 }} /> {getText('aceitar') ?? 'Aceitar'}
                                </button>
                            </div>
                        </>
                    ) : (
                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                            {dados.evento ? (
                                <div className="fin-pp__filters" style={{ marginBottom: 16 }}>
                                    <div className="fin-pp__field">
                                        <label className="fin-pp__label">{getText('data') ?? 'Data'}</label>
                                        <ReactSelect
                                            value={{
                                                value: dados.data || "",
                                                label: dados.nomeData || ""
                                            }}
                                            onChange={e => {
                                                // Atualiza o estado
                                                setDados({
                                                    ...dados,
                                                    data: e.value,
                                                    nomeData: e.label
                                                });

                                                // Salva no localStorage com ID do evento
                                                if (idEvento) {
                                                    localStorage.setItem(`datalista_${idEvento}`, e.value);
                                                    localStorage.setItem(`nomeDatalista_${idEvento}`, e.label);
                                                }
                                            }}
                                            loadOptions={(input) => {
                                                return api({
                                                    method: 'get',
                                                    action: '/evento/datas/' + dados.evento?.id,
                                                    token: token,
                                                    params: {
                                                        nome: input,
                                                    }
                                                })
                                                    .then(response => {
                                                        let options = response.data.data.map(registro => ({
                                                            value: registro,
                                                            label: registro
                                                        }));
                                                        return options;
                                                    })
                                                    .catch(function (error) {
                                                        //console.log(error);
                                                    });
                                            }}
                                            defaultOptions
                                        />
                                    </div>

                                    <div className="fin-pp__field">
                                        <label className="fin-pp__label">{getText('tipoLista') ?? 'Tipo Lista'}</label>
                                        <ReactSelect
                                            id="tipoListaPresenca"
                                            value={{
                                                value: dados.tipoListaPresenca || 1,
                                                label: dados.nomeTipoListaPresenca || "Evento"
                                            }}
                                            onChange={(e) => {
                                                // Atualiza o estado
                                                setDados({
                                                    ...dados,
                                                    tipoListaPresenca: e.value,
                                                    nomeTipoListaPresenca: e.label
                                                });

                                                // Salva no localStorage com ID do evento
                                                if (idEvento) {
                                                    localStorage.setItem(`tipoListaPresenca_${idEvento}`, e.value);
                                                    localStorage.setItem(`nomeTipoListaPresenca_${idEvento}`, e.label);
                                                }
                                            }}
                                            loadOptions={(input) => {
                                                return api({
                                                    method: 'get',
                                                    action: '/participanteListaPresencaTipo',
                                                    token: token,
                                                    params: { nome: input }
                                                })
                                                    .then(response => {
                                                        let options = response.data.data.map((registro) => {
                                                            const label = registro.nome;
                                                            return {
                                                                value: registro.id,
                                                                label
                                                            };
                                                        });
                                                        return options;
                                                    })
                                                    .catch(function (error) {
                                                        //console.log(error);
                                                    });
                                            }}
                                            defaultOptions
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {/* a borda fica no wrapper: clientWidth não conta borda, então o canvas
                                encaixa exato na largura do container e não gera scroll horizontal */}
                            <div
                                ref={caixaAssinatura}
                                style={{
                                    marginBottom: 16,
                                    minHeight: ALTURA_ASSINATURA,
                                    background: '#fff',
                                    border: '1px solid var(--fin-bd)',
                                    borderRadius: 'var(--fin-rds)',
                                    overflow: 'hidden',
                                }}>
                                {larguraAssinatura > 0 ? (
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{
                                            width: larguraAssinatura,
                                            height: ALTURA_ASSINATURA,
                                            style: { display: 'block', maxWidth: '100%' },
                                        }}
                                        ref={elementoAssinatura} />
                                ) : null}
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--pill"
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        elementoAssinatura.current?.clear();
                                    }}>
                                    <FaTrash size={16} style={{ marginRight: 6 }} /> {getText('limpar') ?? 'Limpar'}
                                </button>
                                <button
                                    type="submit"
                                    className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                                    disabled={isLoading || isSubmitting}
                                >
                                    {isLoading ? 'Carregando...' : (isSubmitting ? (getText('salvando') ?? 'Salvando...') : (getText('salvar') ?? 'Salvar'))}
                                </button>
                            </div>
                        </form>
                    )}
                </div>

                {showConfirmarDiaModal && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget) setShowConfirmarDiaModal(false); }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaCalendarAlt size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Confirmar o dia da lista
                                        <span className="fin-pp__modal-sub">{dados.nome || 'Participante'}</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowConfirmarDiaModal(false)}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <p className="fin-pp__cell-muted" style={{ margin: 0 }}>
                                        A assinatura será registrada no dia <strong>{normalizarDataLista(dados.data)}</strong>, que não é o dia de hoje
                                        ({data(new Date())}). Confirma o registro nesse dia?
                                    </p>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={() => setShowConfirmarDiaModal(false)}>Cancelar</button>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--primary"
                                        disabled={isSubmitting}
                                        onClick={() => { setShowConfirmarDiaModal(false); enviarAssinatura(); }}
                                    >
                                        Confirmar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </ErpTemplate>
    );
}
